import WarningIcon from '#/assets/WarningIcon';

import { cFA9400 } from '#/colors';

import { useWalletView } from '#/features/wallet/wallet-context';
import { useConnectOnboardWalletModalActions } from '#/features/wallet/modal-connect-onboard-context';
import * as walletFn from '#/features/wallet/functions';

import { Address, Container } from './atoms';

export default function WalletBadgeRecover() {
  const walletView = useWalletView();
  const modalActions = useConnectOnboardWalletModalActions();

  return (
    <Container onClick={modalActions.open}>
      <WarningIcon size={16} color={cFA9400} />
      <Address>{walletFn.maskAccount(walletView.starknetAddress)}</Address>
    </Container>
  );
}
